export const webp = (function () {
    try {
        return (document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0);
    } catch (err) {
        return false;
    }
})();

export function httpsChk(url) {
    if (typeof window !== 'undefined') {
        let isHttps = window.location.href.toLowerCase().indexOf('https') > -1;
        if (isHttps && url && url.toLowerCase().indexOf('https') < 0) {
            return url.replace('http', 'https');
        }
    }
    return url;
}

export function trimHttp(url) {
    return url ? url.replace(/^http(s)?:/, '') : '';
}

export function webpImg(url, w, h, c = false) {

    if (!url) {
        return url;
    }
    let suffix = url.match(/(.*\.(jpg|jpeg|gif|png))(\?.*)?/);
    // 路径是否包含/bfs/
    let isBfs = url.indexOf('/bfs/') !== -1;
    // 是否是GIF图片
    if (!suffix || suffix[2] === 'gif' || !isBfs) {
        return trimHttp(url);
    }
    // 裁剪规则
    w = Math.ceil(w);
    h = Math.ceil(h);
    let cut = (w && h) ? '@' + w + 'w_' + h + 'h' : '@';
    if (c) cut += '_1c';
    // 图片后参数 比如视频动态图
    let args = suffix[3] ? suffix[3] : '';
    if (webp) {
        return trimHttp(suffix[1] + cut + '.webp' + args);
    } else {
        return trimHttp(suffix[1] + cut + '.' + suffix[2] + args);
    }
}

export function drp() {
    let ratio = 1;
    if (typeof window === 'undefined') return ratio;
    // To account for zoom, change to use deviceXDPI instead of systemXDPI
    if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
        // Only allow for values > 1
        ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
    } else if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
    }
    return ratio === 1 ? 2 : ratio;
}

export function checkInView(el, padding) {
    if (!el) return;
    let rect = el.getBoundingClientRect();
    let p = padding || 0;
    if (rect.x + rect.y + rect.width + rect.height === 0) return false;
    // 只判断了纵向
    return rect.top < window.innerHeight + p && rect.bottom >= 0;
}

export function throttle(fn, delay, mustRunDelay) {
    let timer = null;
    let tStart = 0;
    return function () {
        let context = this;
        let args = arguments;
        let tCurr = +new Date();
        clearTimeout(timer);
        if (!tStart) {
            tStart = tCurr;
        }
        if (tCurr - tStart >= mustRunDelay) {
            fn.apply(context, args);
            tStart = tCurr;
        } else {
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        }
    };
}

export function isEmptyObject(o) {
    return JSON.stringify(o) === '{}';
}

export function bfsImage(url, width, height) {
    if (!url) return url;
    url = httpsChk(url);
    let reg = /i[0-2]/;
    if (reg.test(url)) {
        let arr;
        let urlEnd = '';
        // 带参分割字符串
        if (url.indexOf('?') >= 0) {
            arr = url.split('?');
            url = arr[0];
            urlEnd = '?' + arr[1];
        }
        if (url.indexOf('/bfs/') >= 0 || url.indexOf('/group1/') >= 0) {
            let reg = /_+[0-9]+x[0-9]/;
            if (reg.test(url)) {
                return url;
            }
            let imgtypeArr = url.split('.');
            let imgtype = imgtypeArr[imgtypeArr.length - 1];
            url += '_' + width + 'x' + height + '.' + imgtype;
        } else {
            let reg = /\d+_\d+\//;
            if (reg.test(url)) {
                url = url.replace(reg, '');
            }
            url = url.replace('com/', 'com/' + width + '_' + height + '/');
        }
        url = url + urlEnd;
    }
    return url;
}

export function paramsToKvp(params) {
    if (params && typeof params === 'object') {
        let temp = [];
        for (let k in params) {
            if (params.hasOwnProperty(k) && params[k] !== undefined) {
                let value = typeof params[k] === 'object' ? JSON.stringify(params[k]) : params[k];
                temp.push(`${k}=${encodeURIComponent(value)}`);
            }
        }
        return temp.join('&');
    }
    return '';
}

export function kvpToParams(str) {
    let temp = {};
    if (str && typeof str === 'string') {
        let arr = str.split('&');
        arr.forEach(item => {
            if (item) {
                let itemSplit = item.split('=');
                let value = decodeURIComponent(itemSplit[1]);
                if (value.indexOf('{') > -1) value = JSON.parse(value);
                temp[itemSplit[0]] = value;
            }
        });
    }
    return temp;
}

export function getScrollTop(element = window) {
    if (element === window) {
        return Math.max(window.pageYOffset || 0, window.document.documentElement.scrollTop || window.document.body.scrollTop);
    } else {
        return element.scrollTop;
    }
}

export function jumpToTop(scrollTop = 0) {
    if (document.documentElement.scrollTop !== 0) {
        document.documentElement.scrollTop = scrollTop;
    } else {
        document.body.scrollTop = scrollTop;
    }
}

export function animeScrollTop() {
    if (window.animationScrollTimer !== undefined) {
        window.cancelAnimationFrame(window.animationScrollTimer);
        window.animationScrollTimer = undefined;
    }
    let currentScroll = getScrollTop();
    if (currentScroll > 0) {
        let per = Math.ceil(currentScroll / 30);
        window.animationScrollTimer = window.requestAnimationFrame(function fn() {
            currentScroll -= per;
            if (currentScroll < 0) currentScroll = 0;
            if (window.document.body.scrollTop === 0 && currentScroll !== 0) {
                window.document.documentElement.scrollTop = currentScroll;
            } else if (currentScroll !== 0) {
                window.document.body.scrollTop = currentScroll;
            }
            if (currentScroll <= 0) {
                window.document.documentElement.scrollTop = window.document.body.scrollTop = 0;
                window.cancelAnimationFrame(window.animationScrollTimer);
                window.animationScrollTimer = undefined;
            } else {
                window.animationScrollTimer = window.requestAnimationFrame(fn);
            }
        });
    }
}

export function animeScrollTopV2(offset = 0, speed = 30) {
    if (window.animationScrollTimer !== undefined) {
        window.cancelAnimationFrame(window.animationScrollTimer);
        window.animationScrollTimer = undefined;
    }
    let currentScroll = getScrollTop();
    let per = Math.ceil(Math.abs((offset - currentScroll) / speed));
    if (offset > currentScroll) {
        window.animationScrollTimer = window.requestAnimationFrame(function fn() {
            currentScroll = currentScroll + per;
            if (currentScroll > offset) currentScroll = offset;
            if (window.document.body.scrollTop === 0 && currentScroll !== offset) {
                window.document.documentElement.scrollTop = currentScroll;
            } else if (currentScroll !== offset) {
                window.document.body.scrollTop = currentScroll;
            }
            if (currentScroll === offset) {
                window.document.documentElement.scrollTop = window.document.body.scrollTop = offset;
                window.cancelAnimationFrame(window.animationScrollTimer);
                window.animationScrollTimer = undefined;
            } else {
                window.animationScrollTimer = window.requestAnimationFrame(fn);
            }
        });
    } else {
        window.animationScrollTimer = window.requestAnimationFrame(function fn() {
            currentScroll = currentScroll - per;
            if (currentScroll < offset) currentScroll = offset;
            if (window.document.body.scrollTop === 0 && currentScroll !== offset) {
                window.document.documentElement.scrollTop = currentScroll;
            } else if (currentScroll !== offset) {
                window.document.body.scrollTop = currentScroll;
            }
            if (currentScroll === offset) {
                window.document.documentElement.scrollTop = window.document.body.scrollTop = offset;
                window.cancelAnimationFrame(window.animationScrollTimer);
                window.animationScrollTimer = undefined;
            } else {
                window.animationScrollTimer = window.requestAnimationFrame(fn);
            }
        });
    }
}

export function getWindowW() {
    return window.innerWidth || window.document.documentElement.clientWidth || window.screen.width;
}

export function getWindowH() {
    return window.innerHeight || document.documentElement.clientHeight;
}

export function getAxiosUrl(url, preParams, context) {
    let protocol = (context && context.protocol) ? `${context.protocol}:` : window.location.protocol;
    let paramStr = paramsToKvp(preParams);
    let result = url.indexOf('//') > -1 ? `${protocol}${url}` : `${protocol}//${url}`;
    if (paramStr) {
        result += `?${paramStr}`;
    }
    return result;
}

export function filterText(content) {
    if (!content) return '';
    let result = content.replace(/</g, '&lt;').replace(/>/g, '&gt;'); // 防注入
    result = result.replace(/(\r\n)|(\n)|(\r)/g, '<br/>'); // 替换换行
    result = result.replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;').replace(/ /g, '&nbsp;'); // 替换tab和空格
    return result;
}

export function getScript(url, callback, asyncPolicy) {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.onload = callback;
    asyncPolicy && (script[asyncPolicy] = 'true');
    document.body.appendChild(script);
}

export function biliNumFormat(num, emptyStr = '-') {
    if (typeof num !== 'number') num = Number(num);
    if (num === undefined || isNaN(num) || num <= 0) {
        return emptyStr;
    }
    if (Math.abs(num) <= 10000) {
        return num;
    } else if (Math.abs(num) <= 100000000) {
        return Math.round(num / 1000) / 10 + '万';
    } else {
        return Math.round(num / 10000000) / 10 + '亿';
    }
}

// 自定义数据上报
export function customReport(name, ops) {
    if (window.spmReportData) {
        var obj = ops || name;
        window.spmReportData[name] = obj;
    }
}

export function addClass(el, cls) {
    if (!el) return;
    let curClass = el.className.split(' ');
    let classes = (cls || '').split(' ');
    classes.forEach(item => {
        if (curClass.indexOf(item) < 0) {
            curClass.push(item);
        }
    });
    el.className = curClass.join(' ');
};

export function removeClass(el, cls) {
    if (!el || !cls) return;
    var classes = cls.split(' ');
    var curClass = el.className.split(' ');
    classes.forEach(item => {
        if (curClass.indexOf(item) > -1) {
            let index = curClass.indexOf(item);
            curClass.splice(index, 1);
        }
    });
    el.className = curClass.join(' ');
};

export function quickLogin(cback) {
    if (typeof window.biliQuickLogin === 'function') {
        window.biliQuickLogin(function () {
            if (cback) {
                cback();
            } else {
                window.location.reload();
            }
        });
    } else {
        getScript('//static.hdslb.com/account/bili_quick_login.js', function () {
            window.biliQuickLogin(function () {
                if (cback) {
                    cback();
                } else {
                    window.location.reload();
                }
            });
        });
    }
}

export function biliPay(params, callback, showConfirm = false) {
    if (typeof window.biliPay === 'function') {
        window.biliPay(params, callback, showConfirm);
    } else {
        getScript('//pay.bilibili.com/paysdk/bilipay.js', function () {
            window.biliPay && window.biliPay(params, callback, showConfirm);
        });
    }
}

export function loadDialogFrame(el) {
    if (typeof window !== 'undefined') {
        let isIe = (/MSIE/i).test(window.navigator.userAgent) || (/Trident/i).test(window.navigator.userAgent);
        if (isIe) {
            try {
                let iframe = window.document.createElement('iframe');
                iframe.className = 'bangumi-pay-layout';
                iframe.frameBorder = '0';
                el.appendChild(iframe);
            } catch (e) { }
        }
    }
}

export function objectPolyFill() {
    if (!Object.assign) {
        Object.defineProperty(Object, 'assign', {
            value: function assign(target, varArgs) { // .length of function is 2
                if (target === undefined || target === null) { // TypeError if undefined or null
                    throw new TypeError('Cannot convert undefined or null to object');
                }
                let to = Object(target);
                for (let index = 1; index < arguments.length; index++) {
                    let nextSource = arguments[index];
                    if (nextSource !== null && nextSource !== undefined) { // Skip over if undefined or null
                        for (let nextKey in nextSource) {
                            // Avoid bugs when hasOwnProperty is shadowed
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
                return to;
            },
            writable: true,
            configurable: true
        });
    }
    if (!Object.keys) {
        Object.keys = (function () {
            let hasOwnProperty = Object.prototype.hasOwnProperty;
            let hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString');
            let dontEnums = [
                'toString',
                'toLocaleString',
                'valueOf',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'constructor'
            ];
            let dontEnumsLength = dontEnums.length;
            return function (obj) {
                if ((typeof obj !== 'object' && typeof obj !== 'function') || obj === null) throw new TypeError('Object.keys called on non-object');
                var result = [];
                for (var prop in obj) {
                    if (hasOwnProperty.call(obj, prop)) result.push(prop);
                }
                if (hasDontEnumBug) {
                    for (var i = 0; i < dontEnumsLength; i++) {
                        if (hasOwnProperty.call(obj, dontEnums[i])) result.push(dontEnums[i]);
                    }
                }
                return result;
            };
        })();
    }
    if (!Array.includes) {
        Object.defineProperty(Array, 'includes', {
            value: function (valueToFind, fromIndex) {
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }
                var o = Object(this);
                var len = o.length >>> 0;
                if (len === 0) {
                    return false;
                }
                var n = fromIndex | 0;
                var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
                function sameValueZero(x, y) {
                    return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
                }
                while (k < len) {
                    if (sameValueZero(o[k], valueToFind)) {
                        return true;
                    }
                    k++;
                }
                return false;
            }
        });
    }
    if (!Array.prototype.filter) {
        /* eslint-disable */
        Array.prototype.filter = function (func, thisArg) {
            if (!((typeof func === 'Function' || typeof func === 'function') && this)) {
                throw new TypeError();
            }
            const len = this.length >>> 0;
            const res = new Array(len); // preallocate array
            const t = this;
            let c = 0;
            let i = -1;
            if (thisArg === undefined) {
                while (++i !== len) {
                    // checks to see if the key was set
                    if (i in this) {
                        if (func(t[i], i, t)) {
                            res[c++] = t[i];
                        }
                    }
                }
            } else {
                while (++i !== len) {
                    // checks to see if the key was set
                    if (i in this) {
                        if (func.call(thisArg, t[i], i, t)) {
                            res[c++] = t[i];
                        }
                    }
                }
            }
            res.length = c; // shrink down array to proper size
            return res;
        };
    }
    if (!Array.prototype.some) {
        Array.prototype.some = function (fun/*, thisArg*/) {
            if (this == null) {
                throw new TypeError('Array.prototype.some called on null or undefined');
            }
            if (typeof fun !== 'function') {
                throw new TypeError();
            }
            const t = Object(this);
            const len = t.length >>> 0;
            const thisArg = arguments.length >= 2 ? arguments[1] : void 0;
            for (let i = 0; i < len; i++) {
                if (i in t && fun.call(thisArg, t[i], i, t)) {
                    return true;
                }
            }
            return false;
        };
    }
}

export function reviewUpdate() {
    // 手动开关 评论系统是否处在升级状态 true => 升级中   false => 已结束
    return false;
}

export function reviewUrlChange() {
    // 手动开关 长评详情链接   true => 专栏   false => 旧详情页
    return true;
}

export const SentryIgnore = [
    /Network Error/,
    /(SECURITY_ERR|SecurityError|Illegal invocation|The operation is)/, // 部分浏览器进入了安全模式
    /\$ is not a function/, // CDN 问题
    /Invalid or unexpected/, // 被注入脚本调用 eval 报错
    /UnhandledRejection/,
    /QuotaExceededError/, // localStorage读写太频繁导致 https://stackoverflow.com/questions/21159301/quotaexceedederror-dom-exception-22-an-attempt-was-made-to-add-something-to-st
    /WebViewJavascriptBridge/, // 浏览器调用了自己注入的 js bridge
    /__tv_keydown/, // 位置信息，非业务方问题
    /jinkela\/header\/header.js/, // 顶导的问题
    /jinkela\/header-v2\/header.js/, // 新版本顶导问题
    /.js.map/, // map文件问题
    /\/bfs\/static\/player\/main/, // 播放器js问题
    /\/bfs\/static\/pcdnjs/, // 播放器js问题
    /dash-player\/release\/dash-player/, // 播放器js问题 
    /moz-extension/, // moz扩展插件问题,
    /chrome-extension/, // chrome扩展插件问题
    /comment.min.js/, // 评论js问题
    /(WindVaneAvailableInteractedTime|moz-extension|chrome-extension)/, // 插件注入的方法
    /Loading chunk \d+ failed/, // 某个JS的CDN挂了
    /share_ipad/ // iPad 分享功能
];

export const SentryIgnoreFileLists = [
    '/jinkela/header-v2/header.js', // 顶导的问题
    '/video.js', // 播放器js问题
    '.js.map', // map文件问题
    '/bfs/static/player/main/', // 播放器js问题
    '/bfs/static/pcdnjs', // 播放器js问题
    'dash-player/release/dash-player', // 播放器js问题 
    'comment.min.js', // 评论js问题
    'moz-extension', // moz扩展插件问题
    'chrome-extension'
] 

export function isArray(a) {
    return Object.prototype.toString.call(a).indexOf('Array') > -1;
}

export function isObject(o) {
    return Object.prototype.toString.call(o).indexOf('Object') > -1;
}

/**
 * @param {Array} data 数据
 * return index
 */
export function filterGifIndex(data) {
    let hasGif = false;
    let indexGif = -1;
    data.length && data.forEach((item, i) => {
        if (item.gif && !hasGif) {
            hasGif = true;
            indexGif = i;
        }
    });
    return indexGif;
}

export function getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min; // The maximum is inclusive and the minimum is inclusive
}

export function getStyle(obj, attr) {
    if (obj.currentStyle) {
      return obj.currentStyle[attr];
    } else {
      return document.defaultView.getComputedStyle(obj, null)[attr];
    }
  }

// export function fmSeconds(sec) {
//     if (sec == null) {
//         sec = 0;
//     }
//     let ret;
//     sec = Math.floor(sec) >> 0;
//     ret = ('0' + (sec % 60)).slice(-2);
//     ret = Math.floor(sec / 60) + ':' + ret;
//     if (ret.length < 5) {
//         ret = '0' + ret;
//     }
//     return ret;
// }

export function fmSeconds(sec, hourTime) {
    const hourFormat = !!Math.floor(hourTime / 3600)
    if (sec == null) {
      sec = 0
    }
    let ret
    sec = Math.floor(sec) >> 0
    ret = ('0' + (sec % 60)).slice(-2)
    ret = Math.floor((sec % 3600) / 60) + ':' + ret
    if (ret.length < 5) {
      ret = '0' + ret
    }
    let hour = Math.floor(sec / 3600)
    if (hour || hourFormat) {
      ret = Math.floor(sec / 3600) + ':' + ret
    }
    return ret
  }
